/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState, useCallback } from "react";
import socket from "../../../socket";
import { QRCodeCanvas } from "qrcode.react";
import { toPng } from "html-to-image";
import { formatCurrency, getData } from "../../../utils/SamuiUtils";

const BANNER = "https://files.appsystemyou.com/systemyou/SO_H/974076.jpg";

const BANNER2 =
  "https://files.appsystemyou.com/systemyou/SO_H/FDownloader.Net_AQOV7yCTYTMv41A2EBt2a1k26wKh7QeqChfQJHsaS5Xt2Wg5_uyjuo4OPAxwhrGxutPwF6iRyLcYzfH66AycMgnEMEAM4UF9r_IzlyDPQHRfrA_720p_(HD).mp4";

const BACKEND_URL =
  process.env.REACT_APP_API_URL || "https://pbposuat-backend.appsystemyou.com";
const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || "/socket.io";

/* helpers */
const getURL = () =>
  typeof window !== "undefined" ? new URL(window.location.href) : null;
const getParam = (k) => {
  const u = getURL();
  return u ? u.searchParams.get(k) : null;
};
const removeParam = (k) => {
  const u = getURL();
  if (!u) return;
  u.searchParams.delete(k);
  window.history.replaceState({}, "", u.toString());
};

/* simple hook */
function useWindowWidth() {
  const [w, setW] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );
  useEffect(() => {
    const onR = () => setW(window.innerWidth);
    window.addEventListener("resize", onR);
    return () => window.removeEventListener("resize", onR);
  }, []);
  return w;
}

export default function Page2screenModal({ closeQR, sessionData }) {
  const width = useWindowWidth();
  const socketRef = useRef(null);
  const cardRef = useRef(null);
  const hasPaidRef = useRef(false);
  const currentSessionRef = useRef(null);
  const escHandlerRef = useRef(null);
  const autoPayTimerRef = useRef({ i: null, t: null });
  const hisPaymentIdRef = useRef(null);

  const currentUserName =
    typeof window !== "undefined"
      ? localStorage.getItem("name") || "SYSTEM"
      : "SYSTEM";

  const handleClose = async () => {
    const sid = currentSessionRef.current;
    try {
      // แจ้งฝั่ง server/แคชเชียร์ว่า display ปิดแล้ว (ถ้า endpoint/room มี)
      if (sid && socketRef.current?.emit) {
        socketRef.current.emit("display:qr:closed", { sessionId: sid });
        socketRef.current.emit("leave-room", sid);
      }
      // (optional) ถ้ามี endpoint ยกเลิกบิล
      // await fetch(`${BACKEND_URL}/api/payments/${sid}/cancel`, { method: "POST" }).catch(() => {});
    } finally {
      resetScreen();
      if (typeof closeQR === "function") {
        await closeQR(); // ปิด modal/overlay ที่ component แม่ควบคุม
      }
    }
  };
  
  // state
  const [connected, setConnected] = useState(false);
  const [orderStatus, setOrderStatus] = useState(2); // 0=idle, 2=qr, 1=paid
  const [orderId, setOrderId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [chargeId, setChargeId] = useState(null);
  const [flagVansale, setFlagVansale] = useState(null); // เพิ่ม state สำหรับ Flag_Vansale
  const [isLoadingFlag, setIsLoadingFlag] = useState(true); // สถานะการโหลด
  console.debug("sessionId", sessionId);
  const [promptpayQR, setPromptpayQR] = useState(null);
  const [amount, setAmount] = useState(null);
  const [items, setItems] = useState([]); // << รับรายการสินค้ามาโชว์
  const [ticketList, setTicketList] = useState([]);
  const [order, setOrder] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [showManualModal, setShowManualModal] = useState(false);
  const [saving, setSaving] = useState(false);

  const formatPrice = (v) => {
    const n = Number(v);
    if (isNaN(n)) return "฿ 0";
    return `฿ ${n.toLocaleString()}`;
  };

  // ฟังก์ชันตรวจสอบ Flag_Vansale จาก database
  const checkFlagVansale = useCallback(async () => {
    try {
      setIsLoadingFlag(true);
      const whId = localStorage.getItem("WHID");
      
      if (!whId) {
        console.error("WHID not found in localStorage");
        setFlagVansale("Y"); // default เป็น Y ถ้าไม่มี WHID
        return;
      }

      const result = await getData("Tb_Set_WH", `WH_Id = ${whId}`);
      
      if (result && result.length > 0) {
        const flagValue = result[0].Flag_Vansale;
        setFlagVansale(flagValue);
        console.log("Flag_Vansale:", flagValue);
      } else {
        console.error("No warehouse data found");
        setFlagVansale("Y"); // default เป็น Y ถ้าไม่เจอข้อมูล
      }
    } catch (error) {
      console.error("Error checking Flag_Vansale:", error);
      setFlagVansale("Y"); // default เป็น Y ถ้าเกิด error
    } finally {
      setIsLoadingFlag(false);
    }
  }, []);

  // ตรวจสอบ Flag_Vansale เมื่อ component mount
  useEffect(() => {
    checkFlagVansale();
  }, [checkFlagVansale]);

  // Initialize from sessionData prop if provided
  useEffect(() => {
    if (sessionData) {
      currentSessionRef.current = sessionData.sessionId;
      setSessionId(sessionData.sessionId);
      setOrderId(sessionData.orderId);
      setChargeId(sessionData.chargeId);
      setPromptpayQR(sessionData.promptpayQR);
      setAmount(sessionData.amount);
      setItems(sessionData.items || []);
      setOrderStatus(2); // Show QR
      
      // Join socket room for this session
      if (socketRef.current) {
        socketRef.current.emit("join-room", sessionData.sessionId);
      }
    }
  }, [sessionData]);

  const fetchStatus = useCallback(
    async (sid) => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/payments/${sid}/status`);
        if (!res.ok) return;
        const data = await res.json();
        setOrder({
          Order_no: data.sessionId ?? sid,
          Payment_Date: data.updatedAt ?? new Date().toISOString(),
          Cust_name: data.customerName ?? "",
          Cust_tel: data.customerTel ?? "",
          Pay_By_Name: data.payByName ?? "QR",
          Total_Price: data.amount ?? amount ?? 0,
          Total_Pay: data.balance ?? 0,
          TicketNo_List: (data.seats || []).join(", "),
          img: "",
        });
        // ถ้าฝั่ง backend มี items ก็อาจ map เข้ามาแทนนี้
      } catch (e) {
        console.error("fetchStatus error:", e);
      }
    },
    [amount]
  );

  const handleDownloadOrPrompt = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isIOS && isSafari) return; // ไม่เด้งดาวน์โหลดบน iOS Safari
    if (!cardRef.current) return;
    toPng(cardRef.current).then((dataUrl) => {
      const link = document.createElement("a");
      link.download = "payment-confirmation.png";
      link.href = dataUrl;
      link.click();
    });
  };

  /* Socket.IO */
  useEffect(() => {
    const sock = socket;
    socketRef.current = socket;

    const onConnect = () => {
      setConnected(true);
      console.debug("connected:", sock.id);
      // จอสองทุกเครื่องเข้าห้องกลางไว้ก่อน
      sock.emit("join-room", "DISPLAY");
      sock.emit("display:ready");
    };

    const onDisconnect = (reason) => {
      setConnected(false);
      console.debug("disconnect:", reason);
    };

    const onConnectError = (err) => {
      console.debug("connect_error:", err?.message, err);
    };

    // --- events จากแคชเชียร์/เซิร์ฟเวอร์ ---
    // แสดง QR เข้าห้องเฉพาะบิล
    const onQrShow = (p = {}) => {
      if (!p.sessionId) return;
      
      // If sessionData prop is provided, only respond to matching sessionId
      if (sessionData && sessionData.sessionId !== p.sessionId) return;
      
      console.debug("p", p);
      const sid = String(p.sessionId);
      currentSessionRef.current = sid;
      hisPaymentIdRef.current = p.hisPaymentId || null;
      // เข้าห้อง session เพื่อรออีเวนต์ต่อไปของบิลนี้
      sock.emit("join-room", sid);

      setSessionId(sid);
      setOrderId(sid);
      setChargeId(p.chargeId ?? null);
      setAmount(p.amount ?? null);
      setItems(Array.isArray(p.items) ? p.items : []);
      setPromptpayQR(p.qrData ?? null);
      setOrderStatus(2);
      sock.emit("display:qr:visible", { sessionId: p.sessionId });
    };

    // ปิดบิล/ปิด QR
    const onQrClose = (p = {}) => {
      if (!p.sessionId || p.sessionId !== currentSessionRef.current) return;
      resetScreen();
    };

    // ชำระสำเร็จเฉพาะบิลนี้
    const onPaymentSuccess = (p = {}) => {
      if (!p.sessionId || p.sessionId !== currentSessionRef.current) return;
      hasPaidRef.current = true;
      setOrderStatus(1);
      // ถ้าต้องการดึงสถานะจาก API:
      // fetchStatus(p.sessionId);
      setTimeout(() => resetScreen(), 3500);
    };

    // ยกเลิกเฉพาะบิลนี้
    const onPaymentCancelled = (p = {}) => {
      if (!p.sessionId || p.sessionId !== currentSessionRef.current) return;
      resetScreen();
    };

    sock.on("connect", onConnect);
    sock.on("disconnect", onDisconnect);
    sock.on("connect_error", onConnectError);
    sock.on("qr:show", onQrShow);
    sock.on("qr:close", onQrClose);
    sock.on("payment:success", onPaymentSuccess);
    sock.on("payment:cancelled", onPaymentCancelled);

    // cleanup
    return () => {
      sock.off("connect", onConnect);
      sock.off("disconnect", onDisconnect);
      sock.off("connect_error", onConnectError);
      sock.off("qr:show", onQrShow);
      sock.off("qr:close", onQrClose);
      sock.off("payment:success", onPaymentSuccess);
      sock.off("payment:cancelled", onPaymentCancelled);
    };
  }, []); // อย่าใส่ deps อื่นเพื่อไม่ให้สมัคร event ซ้ำ

  // มี orderId ใหม่ -> ลองดึงสถานะ (เผื่อรีเฟรชหน้า)
  useEffect(() => {
    if (orderId != null) {
      hasPaidRef.current = false;
      setOrder(null);
      fetchStatus(orderId);
    }
  }, [orderId]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") handleClose();
    };
    escHandlerRef.current = onKey;
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    // เริ่มนับเมื่ออยู่สถานะแสดง QR และมี sessionId พร้อมใช้งาน
    if (orderStatus === 2 && sessionId) {
      setCountdown(10);
      // เคลียร์ก่อน (กันซ้อน)
      if (autoPayTimerRef.current?.i) clearInterval(autoPayTimerRef.current.i);
      if (autoPayTimerRef.current?.t) clearTimeout(autoPayTimerRef.current.t);
      // นับถอยหลังทีละวินาที
      const i = setInterval(() => {
        setCountdown((prev) => (prev && prev > 0 ? prev - 1 : 0));
      }, 1000);
      // ครบ 10 วิ -> เรียกจ่ายอัตโนมัติ
      const t = setTimeout(() => {
        // กันเรียกซ้ำ ถ้าเคลียร์ไปแล้วให้ข้าม
        // paidorderStatus(sessionId);
        // setShowManualModal(true);
      }, 13000);
      autoPayTimerRef.current = { i, t };
      return () => {
        clearInterval(i);
        clearTimeout(t);
      };
    } else {
      // ไม่อยู่เงื่อนไข -> ปิดนับถอยหลัง
      setCountdown(null);
      setShowManualModal(false);
      if (autoPayTimerRef.current?.i) clearInterval(autoPayTimerRef.current.i);
      if (autoPayTimerRef.current?.t) clearTimeout(autoPayTimerRef.current.t);
    }
  }, [orderStatus, sessionId]);

  const resetScreen = () => {
    hasPaidRef.current = false;
    hisPaymentIdRef.current = null;
    setOrderStatus(0);
    setCountdown(null);
    setOrder(null);
    setItems([]);
    setPromptpayQR(null);
    setOrderId(null);
    setSessionId(null);
    setChargeId(null);
    setAmount(null);
    try {
      if (autoPayTimerRef.current?.i) clearInterval(autoPayTimerRef.current.i);
      if (autoPayTimerRef.current?.t) clearTimeout(autoPayTimerRef.current.t);
    } catch {}
    removeParam("sessionId");
  };

  // Polling for payment status - แต่ถ้า flagVansale = 'N' จะไม่ใช้ QR
  useEffect(() => {
    if (orderStatus !== 2 || !chargeId || flagVansale === 'N') return;

    const interval = setInterval(async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/payment/qr-tx/${chargeId}`);
        if (res.ok) {
          const data = await res.json();
          if (data.status === "success") {
            // Payment successful, call paidorderStatus to complete the payment
            console.log("Polling: Payment success");
            paidorderStatus(sessionId);
          }
        }
      } catch (e) {
        console.error("Polling error:", e);
      }
    }, 2000); // Poll every 2 seconds

    return () => clearInterval(interval);
  }, [orderStatus, chargeId, sessionId, flagVansale]);

  const paidorderStatus = async (paymentId, isManual = false) => {
    const API_URL = process.env.REACT_APP_API_URL;
    if (!paymentId || saving) return;
    setSaving(true);
    try {
      const response = await fetch(
        `${API_URL}/api/payments/${paymentId}/paid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            hisPaymentId: hisPaymentIdRef.current,
            payBySelf: isManual, // true ถ้ากดปุ่มเอง
            payBySelfBy: isManual ? currentUserName : null,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Payment success:", data);
      setShowManualModal(false);
      setOrderStatus(1);
      setTimeout(() => resetScreen(), 3500);
      return data;
    } catch (error) {
      console.error("Error updating payment status:", error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div
        className="twoscreen"
        style={{
          margin: "auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "10px",
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >
        {/* LEFT */}

        <section className="right-panel">
          {orderStatus === 2 && (
            <div
              className="card qr-card"
              style={{ background: "rgba(26, 32, 48, 1)", border: "none" }}
            >
              {/* header กลาง + ปุ่มปิด */}
              <div className="qr-header">
                <div className="qr-title">กรุณาชำระเงิน</div>
                <button className="close-btn" onClick={handleClose}>
                  ✕
                </button>
              </div>

              <div className="qr-wrap">
                {/* ซ้าย = วิดีโอ */}
                <div className="qr-box2">
                  <div className="banner">
                    <video
                      src={BANNER2}
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="banner-video"
                    />
                  </div>
                </div>

                {/* ขวา = แสดง QR หรือ ปุ่มยืนยัน ขึ้นอยู่กับ Flag_Vansale */}
                <div className="qr-col">
                  <div className="qr-box">
                    {isLoadingFlag ? (
                      <div className="subtitle">กำลังโหลด...</div>
                    ) : flagVansale === 'N' ? (
                      // แสดงปุ่มยืนยันแทน QR เมื่อ Flag_Vansale = 'N'
                      <div className="manual-payment-container">
                        {/* <div className="manual-payment-text">
                          ไม่สามารถแสดง QR Code ได้
                        </div> */}
                        <button
                          className="btn btn-warning text-white d-flex align-items-center justify-content-center"
                          style={{ 
                            width: 240, 
                            height: 50,
                            fontSize: '18px',
                            fontWeight: 'bold',
                            borderRadius: '12px',
                            marginTop: '20px'
                          }}
                          onClick={() => paidorderStatus(sessionId, true)}
                          disabled={!sessionId || saving}
                        >
                          {saving ? 'กำลังดำเนินการ...' : 'ยืนยันชำระด้วยตัวเอง'}
                        </button>
                      </div>
                    ) : (
                      // แสดง QR ตามปกติเมื่อ Flag_Vansale = 'Y'
                      <>
                        {promptpayQR ? (
                          typeof promptpayQR === "string" &&
                          (/^https?:\/\//.test(promptpayQR) || promptpayQR.startsWith("data:image/") || promptpayQR.startsWith("/")) ? (
                            <img
                              src={promptpayQR}
                              alt="QR"
                              className="qr-image"
                            />
                          ) : (
                            <QRCodeCanvas
                              value={String(promptpayQR ?? "")}
                              size={320}
                              className="qr-canvas"
                              includeMargin
                            />
                          )
                        ) : (
                          <div className="subtitle">กำลังเตรียม QR…</div>
                        )}
                      </>
                    )}
                  </div>

                  {/* ราคา */}
                  {amount != null && (
                    <div className="price-tag">
                      <span className="price-label">ราคา</span>{" "}
                      <span className="price-value">
                        {formatCurrency(amount)} บาท
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* ปุ่มด้านล่างสำหรับกรณีที่มี QR (Flag_Vansale = 'Y') */}
              {sessionId && flagVansale !== 'N' && (
                <div className="subtitle" style={{ marginTop: "-40px" }}>
                  <button
                    className="btn btn-warning text-white d-flex align-items-center justify-content-center"
                    style={{ width: 185, height: 40 }}
                    onClick={() => paidorderStatus(sessionId, true)}
                  >
                    ยืนยันชำระด้วยตัวเอง
                  </button>
                </div>
              )}
            </div>
          )}

          {orderStatus === 1 && (
            <div
              ref={cardRef}
              className="card paid-card"
              style={{
                position: "relative",
                background: "#fff",
                height: "86vh",
                display: "grid",
                placeItems: "center",
              }}
            >
              <img
                src="paid.png"
                alt="paid"
                style={{ width: "65%", height: "100%", objectFit: "contain" }}
              />
            </div>
          )}
        </section>
      </div>

      {showManualModal && orderStatus === 2 && (
        <div className="modal-backdrop">
          <div className="modal-card">
            <div className="modal-title">สัญญาณอินเตอร์เน็ต ไม่เสถียร</div>
            <div className="modal-body">
              กรุณากด <b>บันทึก</b> เพื่อทำการจ่ายสำเร็จ
            </div>
            <div className="modal-actions">
              <button
                className="btn"
                onClick={() => setShowManualModal(false)}
                style={{
                  background: "red",
                  color: "white",
                  borderRadius: "13%",
                }}
              >
                ปิด
              </button>
              <button
                className="btn btn-primary"
                onClick={() => paidorderStatus(sessionId)}
                disabled={!sessionId || saving}
              >
                {saving ? "กำลังบันทึก..." : "บันทึก"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== styled-jsx global ===== */}
      <style jsx global>{`
        .twoscreen {
          height: 100vh;
          display: grid;
          grid-template-columns: 480px 1fr;
          gap: 24px;
          max-width: 1320px;
          margin-inline: auto;
        }

        /* การ์ดหลักของ QR */
        .qr-card {
          position: relative;
        }

        /* header กลาง */
        .qr-header {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 8px 40px 4px;
        }
        .qr-title {
          color: #fae902ff;
          font-weight: 800;
          font-size: 22px;
          text-shadow: 0 1px 0 #000, 0 2px 6px rgba(0, 0, 0, 0.45);
          position: relative;
          right: 90px;
        }

        /* ปุ่ม X มุมขวาบน */
        .close-btn {
          position: absolute;
          right: 6px;
          top: 2px;
          width: 32px;
          height: 32px;
          border: 0;
          border-radius: 50%;
          background: #222;
          color: #ee0e0eff;
          font-weight: 800;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
        }
        .close-btn:hover {
          filter: brightness(1.1);
        }

        /* เลย์เอาต์ซ้าย-ขวา */
        .qr-wrap {
          display: grid;
          grid-template-columns: 300px 1fr;
          gap: 28px;
          align-items: flex-start;
          margin-top: 6px;
        }

        /* คอลัมน์ขวาให้เรียง QR แล้วราคา */
        .qr-col {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        /* กล่อง QR */
        .qr-box {
          width: 360px;
          height: 385px;
          border-radius: 18px;
          background: #0e1320;
          display: grid;
          place-items: center;
          border: 1px solid rgba(255, 255, 255, 0.08);
        }

        .qr-image,
        .qr-canvas {
          width: 82%;
          height: 82%;
          object-fit: contain;
        }

        /* สไตล์สำหรับกรณี Flag_Vansale = 'N' */
        .manual-payment-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }

        .manual-payment-text {
          color: #fae902ff;
          font-size: 18px;
          font-weight: 600;
          text-align: center;
          margin-bottom: 10px;
        }

        /* วิดีโอฝั่งซ้าย */
        .banner {
          position: relative;
          overflow: hidden;
          border-radius: 16px;
          height: 380px;
          width: 270px;
        }
        .banner-video {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* ป้ายราคา */
        .price-tag {
          align-self: flex-start;
          padding: 8px 14px;
          border-radius: 10px;
          color: #fae902ff;
          font-weight: 800;
          position: relative;
          left: 90px;
          font-size: 22px;
        }
        .price-tag .price-label {
          opacity: 0.85;
          margin-right: 6px;
        }
        .price-tag .price-value {
          color: #fae902ff;
          font-weight: 800;
          font-size: 22px;
          text-shadow: 0 1px 0 #000, 0 2px 8px rgba(0, 0, 0, 0.35);
        }

        @media (max-width: 1024px) and (max-height: 600px) {
          .twoscreen {
            grid-template-columns: 360px 1fr;
            gap: 16px;
            max-width: 100%;
          }

          .qr-wrap {
            grid-template-columns: 240px 1fr;
            gap: 16px;
            align-items: start;
          }

          .banner {
            width: 220px;
            height: 310px;
          }

          .qr-box {
            width: 250px;
            height: 250px;
          }

          .qr-image,
          .qr-canvas {
            width: 88%;
            height: 88%;
          }

          .qr-col {
            gap: 10px;
            align-items: center;
          }

          .price-tag {
            position: static;
            left: auto;
            align-self: center;
            padding: 0;
            text-align: center;
            font-size: 18px;
          }

          .price-tag .price-value {
            font-size: 18px;
          }
        }

        /* ===== Modal styles ===== */
        .modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          display: grid;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          position: absolute;
          left: -35vw;
          top: -30vh;
        }
        .modal-card {
          width: min(92vw, 480px);
          background: #0e1320;
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 20px 18px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
        }
        .modal-title {
          font-size: 20px;
          font-weight: 800;
          color: #ffcc00;
          margin-bottom: 8px;
          justify-self: center;
        }
        .modal-body {
          font-size: 16px;
          opacity: 0.95;
          margin-bottom: 16px;
          justify-self: center;
        }
        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
        .btn.btn-primary {
          background: #ffcc00;
          color: #000;
          border: none;
          border-radius: 10px;
          padding: 8px 14px;
          font-weight: 700;
          cursor: pointer;
        }
        .btn.btn-secondary {
          background: #2a2f3e;
          color: #fff;
          border: none;
          border-radius: 10px;
          padding: 8px 14px;
          cursor: pointer;
        }
        .btn.btn-primary:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      `}</style>
    </>
  );
}
